import { FC } from 'react';
import { BackgroundVideo } from '../BackgroundVideo';

export const BgBubbles: FC = () => (
  <div className="absolute w-full h-full overflow-hidden bg-gradient-to-br from-gradient-from to-gradient-from -z-1">
    <BackgroundVideo
      className="absolute bottom-0 right-0 w-full h-full max-w-[550px] sm:p-2 md:p-6 lg:p-0 lg:m-10 xl:m-12"
      name="bubbles"
      resolutions={[550, 1100]}
      formats={['webm', 'mp4']}
      playbackRate={0.75}
    />
  </div>
);
